export const defaultConfig = {
  core: {
    pluginName: "DrawingTool",
    debug: false
  },
  canvas: {
    width: 960,
    height: 540,
    background: "#ffffff",
    responsive: true,
    showGrid: false
  },
  coordinates: {
    unit: "m",
    scale: 1,
    displayUnit: "m"
  },
  viewport: {
    zoom: 1,
    minZoom: 0.25,
    maxZoom: 4,
    panX: 0,
    panY: 0,
    zoomStep: 1.2,
    panStep: 48,
    wheelZoom: true,
    keyboard: true
  },
  grid: {
    visible: false,
    spacing: 1,
    unit: "m",
    subdivisions: 4,
    color: "#c6d1d8",
    subgridColor: "#e3e8ec",
    lineWidth: 1,
    subgridLineWidth: 1
  },
  measurements: {
    visible: true,
    displayUnit: "m",
    precision: 2,
    labelColor: "#172026",
    labelBackground: "rgba(255, 255, 255, 0.86)"
  },
  tools: {
    defaultTool: "line",
    enabled: ["dot", "line", "rectangle", "cut-line", "pan-zoom"],
    pointHitTolerance: 8,
    lineCutTolerance: 8
  },
  toolOptions: {
    strokeColor: "#111111",
    fillColor: "#d9ecff",
    lineWidth: 2,
    dotRadius: 4,
    rectangleFilled: false
  },
  styles: {
    stroke: "#111111",
    fill: "transparent",
    lineWidth: 2,
    dotRadius: 4
  },
  data: {
    version: 1,
    autosave: false
  },
  ui: {
    showToolbar: true,
    showToolOptions: true,
    showDebugPanel: false
  }
};

export function mergeConfig(baseConfig, overrideConfig = {}) {
  const output = { ...baseConfig };

  for (const [key, value] of Object.entries(overrideConfig)) {
    if (isPlainObject(value) && isPlainObject(output[key])) {
      output[key] = mergeConfig(output[key], value);
      continue;
    }

    output[key] = value;
  }

  return output;
}

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
